import gql from 'graphql-tag';

export const REMOVE_FROM_WAITING_LIST = gql`
    mutation (
        $input: MarketingCampaignParticipantListInput!
        $marketingCampaignId: String!
    ) {
        removeFromWaitingList (
            input: $input
            marketingCampaignId: $marketingCampaignId
        )
    }
`;